import React, { useEffect, useState } from "react";
import { api } from "../api";
import StaffAccessManager from "../components/StaffAccessManager.jsx";

export default function Users() {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "", role: "caregiver" });

  const load = () => api.users.list().then(setUsers).catch((e) => setError(e.message));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    setError("");
    setNotice("");
    try {
      const result = await api.users.create(form);
      setForm({ name: "", email: "", password: "", phone: "", role: "caregiver" });
      if (result.email_sent) {
        setNotice(`User created — a welcome email was sent to ${result.email}.`);
      } else {
        setError(`User created, but the welcome email did NOT send (${result.email_error || "email not configured"}). Please share the password with them directly.`);
      }
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  const resetPassword = async (id, name) => {
    const newPassword = prompt(`Set a new password for ${name} (min 6 characters):`);
    if (!newPassword) return;
    if (newPassword.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }
    setError("");
    setNotice("");
    try {
      const result = await api.users.resetPassword(id, newPassword);
      if (result.email_sent) {
        setNotice(`Password updated and emailed to ${name}.`);
      } else {
        alert(`Password updated for ${name}, but the email did NOT send (${result.email_error || "email not configured"}). Share it with them directly.`);
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const remove = async (id) => {
    if (!confirm("Remove this caregiver's account?")) return;
    await api.users.remove(id);
    load();
  };

  return (
    <div>
      <StaffAccessManager />
      <h1 className="text-2xl font-bold mb-1" style={{ color: "#154E93" }}>Caregivers &amp; administrators</h1>
      <p className="text-sm text-gray-500 mb-6">Manage who can log in and take training</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow-sm p-4">
          <h2 className="font-semibold mb-3" style={{ color: "#154E93" }}>Add Caregiver / Admin</h2>
          {error && <div className="mb-3 text-sm bg-red-50 text-red-700 px-3 py-2 rounded">{error}</div>}
          {notice && <div className="mb-3 text-sm bg-green-50 text-green-700 px-3 py-2 rounded">{notice}</div>}
          <form onSubmit={create} className="space-y-3">
            <input required placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full border rounded px-2 py-1.5 text-sm" />
            <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full border rounded px-2 py-1.5 text-sm" />
            <input placeholder="Phone (optional)" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="w-full border rounded px-2 py-1.5 text-sm" />
            <input required type="password" placeholder="Temporary password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full border rounded px-2 py-1.5 text-sm" />
            <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="w-full border rounded px-2 py-1.5 text-sm">
              <option value="caregiver">Caregiver</option>
              <option value="admin">Admin</option>
            </select>
            <button type="submit" className="w-full py-2 rounded text-white text-sm font-medium" style={{ backgroundColor: "#154E93" }}>
              Add User
            </button>
          </form>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-4">
          <h2 className="font-semibold mb-3" style={{ color: "#154E93" }}>Everyone with access</h2>
          <table className="w-full text-sm">
            <tbody>
              {users.map((u) => (
                <tr key={u.id} className="border-b last:border-0">
                  <td className="py-2">
                    <div className="font-medium">{u.name}</div>
                    <div className="text-xs text-gray-500">{u.email}{u.phone ? ` · ${u.phone}` : ""}</div>
                  </td>
                  <td className="py-2 text-xs uppercase text-gray-500">{u.role}</td>
                  <td className="py-2 text-right space-x-3">
                    <button onClick={() => resetPassword(u.id, u.name)} className="text-blue-600 hover:underline text-xs">Reset password</button>
                    <button onClick={() => remove(u.id)} className="text-red-600 hover:underline text-xs">Remove</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
